export enum Season {
  Winter = 'winter',
  Spring = 'spring',
  Summer = 'summer',
  Fall = 'fall',
}

export const seasons = Object.values(Season);
